// askSmart-ui/src/pages/TOSP/portal/ExpenseStatement.tsx
import React from "react";
import { Tenant, tenantLabel } from "../types";
import ExpenseTable from "./ExpenseTable";
import { TenantSalesMonth } from "./tenantSales";

interface ExpenseStatementProps {
  tenant: Tenant;
  sales: TenantSalesMonth[];
  onBack: () => void;
}

// The tenant's own view of what they are invoiced. The table itself is shared
// with the admin's Tenant Details modal — see ExpenseTable — so this screen is
// only the page around it.
export default function ExpenseStatement({ tenant, sales, onBack }: ExpenseStatementProps) {
  return (
    <div className="tosp-portal tosp-portal-wide">
      <header className="tosp-portal-detail-header">
        <button type="button" className="tosp-portal-back" onClick={onBack}>
          ‹ Dashboard
        </button>
        <h1 className="tosp-portal-detail-title">
          Expenses <span className="tosp-portal-detail-who">({tenantLabel(tenant)})</span>
        </h1>
      </header>

      <ExpenseTable tenant={tenant} sales={sales} />
    </div>
  );
}
